export default __webpack_public_path__ + "static/inline-message.dark-d3dde4c010af93ab8703a3c07859786c1e0ef1d105147f122c7f54ed21bf8f81.png";